export default {
  views: {
    basket: {
      shopNow: 'Shop Now',
      yourBasket: '<strong>Your Basket</strong> ({0} items): <strong>{1}</strong>',
      noItems: "We've got some neat stuff that your basket would love!",
      licenseTitle: 'License and Fees',
      licenseTotal: 'Total Licensing Fees',
      replacementTitle: 'Replacement Tags',
      tagTitle: 'Pet Tags',
      petProductTitle: 'Pet Products And Memberships',
      productTitle: 'Products',
      walletCardProductTitle: 'Wallet Cards',
      duplicateWalletCard: 'Duplicate Wallet Card',
      petIdentificationCard: 'Pet Identification Card',
      walletCardMissingInfo: 'Your Wallet Card is missing info!',
      walletCardFinishPet: "Finish {petName}'s card",
      walletCardAssignPet: 'Assign a pet to your card',
      additionalFeesTitle: 'Additional Fees',
      donationTitle: 'Donations',
      vsTitle: 'Items for Voice & Sight',
      vsPetTitle: 'Pets',
      vsGuardianTitle: 'Pet Owner Or Guardians',
      addAnother: [
        'BUY MORE & SAVE MORE ON TAGS!',
        'Add another tag and SAVE $5!',
        'Add another tag and SAVE $15!',
        'Add another tag for just $10!',
      ],
      checkout: 'Checkout',
      login: 'Login to Checkout',
      continueShopping: 'Continue Shopping',
      shipping: 'Free shipping on all orders over $00.00',
      returnPolicy: 'Something about our return policy',
      warranty: 'Something about our warranty',
      tooltip: {
        penaltyFee:
          'License fees are subject to a penalty if any person fails to pay the required license renewal fee within thirty (30) days of its due date. Penalty fees are cumulative based on the number of years a pet failed to be licensed.',
      },
      petTrackerAddedMessaging:
        '<strong>{petName} is so lucky! </strong> Now you can stay connected to his location, health and activity with real-time insights right from your phone.',
      homeSafeReminder: "Remember, you'll need to create a DocuPet account to take advantage of the Home<em>Safe</em><sup>&reg;</sup> 24/7 lost pet service.",
      cancelOrder: 'Cancel Order'
    },
    confirmation: {
      thanks: 'Thank you for your purchase!',
      orderNumber: 'Order #{0}',
      gettingReady: "We're getting your order ready for shipment. We will notify you when it has been sent.",
      toAccount: 'Go to My Account',
      viewOrder: 'View your Order',
      summary: 'Order Summary',
      membershipCTA: {
        title: 'More Support for You and Your Pets',
        body: 'Discover enhanced membership benefits that make everyday pet care fun and easy.',
        button: 'Explore Memberships',
      },
    },
    interrupt: {
      title: 'This tag is not a Pet License yet!',
      body: "We are the official licensing partner of {cityName}. In order for your selected tag(s) to double as your pet's license, you must purchase a license in addition to your selected tag(s). | We are the official licensing partner of {cityName}. In order for your selected tag(s) to double as your pets' license, you must purchase a license in addition to your selected tag(s).",
      buttonPurchaseLicense: 'Purchase a pet license now! | Purchase pet licenses now!',
      buttonContinue:
        "I understand. I'll purchase a pet license later! | I understand. I'll purchase pet licenses later!",
    },
    donation: {
      wouldYouLike: 'Would you like to make a donation to our Safe&Happy Fund?',
      netProceeds:
        'In {1} net proceeds collected through DocuPet’s Safe&Happy Fund are donated to {0}. Please note that donations made to the Safe&Happy Fund are not tax-deductible. You may receive a tax receipt if you donate to {0} directly.',
      selectAmount: 'Select your donation amount',
      continue: 'Add Donation and Continue to Checkout',
      skip: 'No Donation Today, Thanks - Continue',
      cartTotal: 'Cart Total: {0}',
      roundUpDonation: '<b>Round up my order to {0}</b><br />A donation of {1}',
      validation: {
        min: 'The minimum custom donation amount is ${min}.',
        max: 'The maximum custom donation amount is ${max}.',
        invalid: 'Please enter a valid donation amount.',
      },
    },
    payment: {
      donationSuccess: 'Donation added. Thank you!',
      place: 'Place Your Order',
      shippingTo: 'Shipping to: ',
      editAddress: 'Edit',
      error: 'Uhoh! There was an error processing your card.',
      info: 'Payment Information',
      creditDebit: 'Credit Card',
      onFile: 'Card on File',
      useFile: 'Use Card on File',
      useDifferent: 'Use a Different Card',
    },
  },
  basketPlusSavingsBanner: {
    headline: "Claim {petName}'s Protection Plus benefits",
    body: 'Your plan includes select items for free. Plan benefits and promotions are automatically applied at checkout.',
    shopNow: 'Shop now!',
  },
  components: {
    discount: {
      notApplyTip:
        'Promo codes do not apply to pet licensing fees, late fees, replacement pet tags, bundle items, specific sale items, or automatically discounted items.',
      success: '',
      error: '',
      excludesSaleItems: 'Promo Codes cannot be used on Sale items.',
      automatedDiscountBlocksPromo: 'A membership discount is already applied to this order, so promo codes cannot be used.',
    },
    petHeader: {
      for: 'Items for {0}',
    },
    product: {
      personalization: 'Personalization',
      addPersonalization: 'Add Personalization for',
      input: {
        petName: {
          placeholder:'Enter pet\'s name here'
        }
      },
      matchingKeyChain: 'Matching Keychain',
      upgradeTo: 'Upgrade to {productName} for',
      glowTag: 'Add a GlowTag for',
      addMatchingKeyChain: 'Add a Matching Keychain for',
      splitRing: 'Split Ring Connector Included',
      petHomeSafeId: "Pet's [Home<em>Safe</em><sup>&reg;</sup> ID]",
      free: 'FREE',
      automatedDiscountLabel: {
        named: '{triggerName} Discount Applied',
        _default: 'Automated Discount Applied',
      },
    },
    stripe: {
      AM: 'Amex',
      MC: 'Mastercard',
      VI: 'Visa',
      NN: 'Discover',
      XX: 'Card',
      profile: '{0} ending in {1} expiring on {2}/{3}',
    },
    totals: {
      subtotal: 'Subtotal',
      discount: 'Discount',
      shipping: {
        regular: {
          text: 'Regular Mail Shipping',
        },
        priority: {
          upgradeText: 'Upgrade to Priority Shipping ${0}',
          downgradeText: 'Change to Regular Mail Shipping (Free)',
        },
      },
      free: 'FREE',
      tax: 'Tax ({0}) {1}%',
      fees: 'Fees',
      feesTip: "This fee covers the costs of completing your order.",
      replacementTagFees: 'Replacement tag processing fee',
      replacementTagFeesTip: 'A processing fee is applied to help cover the credit card charges to process your order',
      donation: 'Donation',
      total: 'Total',
    },
    removeBundleItemConfirmation: {
      title: 'Are you sure you want to remove this item from your basket?',
      message: "This will remove all of the items associated with {petName}'s Pet ID Bundle.",
      messageNoPet: 'This will remove all of the items associated with the Pet ID Bundle.',
      confirmButtonText: 'Yes, remove the item',
      cancelButtonText: 'No, keep this item',
    },
    petFooter: {
      addDesignerTag: 'Add a designer tag for {petName}! | Add another designer tag for {petName}!',
      chooseTagForNextPet: 'Choose a tag for {petName}',
    },
  },
  membership: {
    switchError: 'We could not change the billing frequency. Please try again.',
    switchToMonthly: 'Switch to monthly billing ({price})',
    switchToAnnual: 'Switch to yearly and save {saving}',
    switchToAnnualNoSaving: 'Switch to yearly billing ({price})',
    nowBilledMonthly: 'Now billed monthly, {price} per month.',
    nowBilledAnnually: 'Now billed yearly, {price} per year.',
    // Mirrored verbatim from translations/petowner/membership+intl-icu.en_US.xlf
    monthly_commitment_ack: 'I understand this is a 1-year commitment and agree to be auto-billed each month for 12 months.',
    monthly_commitment_ack_error: 'Please check the box to acknowledge the 1-year commitment and billing terms.',
  },
  meta: {
    title: {
      Basket: 'Basket',
      Checkout: 'Checkout',
      Interrupt: 'Interrupt',
      Donation: 'Donation',
      Payment: 'Payment',
      Confirmation: 'Confirmation',
    },
  },
};
